import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import useScrollListener from '../common/listenScroll'
import { Divide as Hamburger } from 'hamburger-react' 
import styled from 'styled-components';
import Logo from '../../asset/logo.png';
import whitepaper from '../../asset/desktop/checklist.png'
import styles from './styles.css'

/* eslint-disable */

const Home = ({menu, setMenu}) => {
  const handleToggle = () => {
    setMenu((prevState) => {
      return !prevState;
    })
  }

  const [navClassList, setNavClassList] = useState([]);
  const scroll = useScrollListener();

  useEffect(() => {
    const _classList = [];

    if (scroll.y > 150 && scroll.y - scroll.lastY > 0)
      _classList.push("nav-bar--hidden");

    setNavClassList(_classList);
  }, [scroll.y, scroll.lastY]);

  return (
    <Header className={`${navClassList.join(" ")}`}>
      <nav className="w-full">
        <div className = 'flex items-center ham-cont justify-between sm:px-10 sm:h-20 px-5'>
          <div>
            <img src = {Logo} alt = "logo" />
          </div>

          <div className = 'whitepaper text-white hidden sm:block'>
            <button className = 'py-1 px-2 font-semibold text-lg' type = "submit">
              <img src = {whitepaper} alt = 'whitepaper' className = 'inline-block' />            
                Whitepaper
            </button>
          </div>

          <div className = 'block sm:hidden ham'>
            <Hamburger onToggle = {handleToggle} toggled = {menu} /> 
          </div>
        </div>

        <ul className = 'h-10 w-full sm:flex justify-around items-center px-10 hidden sm:block'>
          <li>
            <NavLink to = '/' exact = {true}>
              Home
            </NavLink>
          </li>

          <li>
            <NavLink to = '/protocol'>
              Protocol
            </NavLink>
          </li>

          <li>
            <NavLink to = '/governance'>
              Governance
            </NavLink>
          </li>

          <li>
            <NavLink to = '/technology'>
              Technology
            </NavLink>
          </li>
        
          <li>
            <NavLink to = '/information'>
              Information
            </NavLink>
          </li>

          <li>
            <NavLink to = 'defi'>
              DeFi
            </NavLink>
          </li>

          <li>
            <NavLink to = '/incentives'>
              Incentives
            </NavLink>
          </li>

          <li>
            <NavLink to = '/people'>
              People
            </NavLink>
          </li>
        </ul>


        {menu && (
          <div className = 'mobile sm:hidden'>
            <ul className = 'sidebar'>
              <li className = 'mt-20'>
                <NavLink to = '/' exact = {true} onClick = {handleToggle} className = 'w-full'>
                  Home
                </NavLink>
              </li>

              <li>
                <NavLink to = '/protocol' onClick = {handleToggle}>
                  Protocol
                </NavLink>
              </li>

              <li>
                <NavLink to = '/governance' onClick = {handleToggle}>
                  Governance
                </NavLink>
              </li>

              <li>
                <NavLink to = '/technology' onClick = {handleToggle}>
                  Technology
                </NavLink>
              </li>
            
              <li>
                <NavLink to = '/information' onClick = {handleToggle}>
                  Information
                </NavLink>
              </li>

              <li>
                <NavLink to = 'defi' onClick = {handleToggle}>
                  DeFi
                </NavLink>
              </li>

              <li>
                <NavLink to = '/incentives' onClick = {handleToggle}>
                  Incentives
                </NavLink>
              </li>

              <li>
                <NavLink to = '/people' onClick = {handleToggle}>
                  People
                </NavLink>
              </li>

              <div className = 'whitepaper text-white text-center'>
                <button className = 'font-semibold py-2 px-3 text-lg' type = "submit">
                  <img src = {whitepaper} alt = 'whitepaper' className = 'inline-block' /> Whitepaper
                </button>
              </div>
            </ul>
          </div>
        )}
      </nav>
    </Header>
   )
};
;

const Header = styled.nav`
  font-family: 'GreyCliff-DemiBold', sans-serif;
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  z-index: 1000000000;
  transition: transform 150ms ease-in-out;
  box-shadow: 0 4px 2px -2px rgba(0, 0, 0, .1);
  
  ul {
    background: #F0F7FF;
    li {
      font-size: 1.125rem;
      a.active {
        color: #FF6495;
      }
    }
  }

  .whitepaper {
    cursor: pointer;
    button {
      border-radius: 5px;
      box-shadow: 0 0 10px rgb(170, 170, 170);
      background: #FF6495;
    }
  }

  .whitepaper img {
    height: 15px;
  }

  .mobile{
    z-index: 100;
  }

  .mobile {
    animation-name: scroll-down;
    animation-duration: .5s;
    /* height: 93vh; */

    ul {
      background: none;
    }

    li {
      font-weight: 600;
      font-size: 1rem;

      a {
        display: block;
        padding-left: 2.5rem;
        padding-top: 1.0rem;
        padding-bottom: 1.0rem;
      }

      a.active {
        background: #FFF8FA;
      }
    }

    @keyframes scroll-down {
      from {
        transform: translateX(-100%);
      }

      to {
        transform: translateX(0%);
      }
    }
  }

  .ham-cont {
      z-index: 1000;
      position: relative;
    }

    .mobile {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
    
    .mobile {
      height: 100vh;
      background: #fff;
      .sidebar li {
        /* margin-bottom: 1.5rem; */
      }
    }

  @media screen and (max-width: 650px) {
    /* .ham-cont {
      position: fixed;
      left: 0;
      right: 0;
      box-shadow: 5px 5px 10px rgba(255, 255, 255, .3);
      position: -webkit-sticky;
      top: 0;
    } */
    /* .hey {
      height: 200px;
    } */

    .ham-cont {
      /* position: sticky; */
      /* position: -webkit-sticky; */
      /* top: 0; */
      /* height: 100%; */
    }
  }
`

export default Home;
